import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import LoginBox from './LoginBox';

const LoginMutation = gql`
  mutation login(
    $email: String!
    $password: String!
  ) {
    login (
      email: $email
      password: $password
    ) {
      token,
      user {
        id
        
        email
        phone
        
        receiveNewsletter
        
        companyInformation
        companyName
        companyRegistrationNumber
        companyVatNumber

        invoiceFirstName
        invoiceLastName
        
        invoiceStreet
        invoiceHouseNumber
        invoiceAddressLine1
        invoiceAddressLine2
        invoiceZip
        invoiceCity
        invoiceCountyState
        invoiceCountry

        anotherDeliveryAddress
        deliveryStreet
        deliveryHouseNumber
        deliveryAddressLine1
        deliveryAddressLine2
        deliveryZip
        deliveryCity
        deliveryCountyState
        deliveryCountry

        saleTaxCertificate

        discount

        customerGroup {
          id
          name
          discount
        }

        customerGroups {
          id
          name
          discount
          description
          fields
        }

        customerGroupsData
      }
      country {
        id
        parentCountryId
        name
        title
        details
        slug
        VATrate
        currency
        language
        code
        flag
        weightUnit
        states {
          id
          name
          title
          vatRate
        }
      }
    }
  }
`;

const Auth0LoginMutation = gql`
  mutation login(
    $auth0AccessToken: String!
  ) {
    login (
      email: $email
      password: $password
    ) {
      token,
      user {
        id
        
        email
        phone
        
        receiveNewsletter
        
        companyInformation
        companyName
        companyRegistrationNumber
        companyVatNumber

        invoiceFirstName
        invoiceLastName
        
        invoiceStreet
        invoiceHouseNumber
        invoiceAddressLine1
        invoiceAddressLine2
        invoiceZip
        invoiceCity
        invoiceCountyState
        invoiceCountry

        anotherDeliveryAddress
        deliveryStreet
        deliveryHouseNumber
        deliveryAddressLine1
        deliveryAddressLine2
        deliveryZip
        deliveryCity
        deliveryCountyState
        deliveryCountry

        saleTaxCertificate

        discount

        customerGroup {
          id
          name
          discount
        }

        customerGroups {
          id
          name
          discount
          description
          fields
        }

        customerGroupsData
      }
      country {
        id
        parentCountryId
        name
        title
        details
        slug
        VATrate
        currency
        language
        code
        flag
        weightUnit
        states {
          id
          name
          title
          vatRate
        }
      }
    }
  }
`;
interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

export default compose(
  graphql<IInputProps, IResponse>(Auth0LoginMutation, {
    name: 'auth0login'
  }),
  graphql<IInputProps, IResponse>(LoginMutation, {
    name: 'login'
  })
)(LoginBox);



// WEBPACK FOOTER //
// ./src/components/Query/User/Login/index.tsx